import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/project/front-org/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/project/front-org/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["ITParkRating","ITParkRatingLoader"] */ "/srv/project/front-org/src/app/[locale]/pages/[page_code]/ITParkRating/ITParkRating.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Documents"] */ "/srv/project/front-org/src/components/global/documents/Documents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/srv/project/front-org/src/components/global/error-boundary/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalInfo"] */ "/srv/project/front-org/src/components/global/external-info/ExternalInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeedbackForm"] */ "/srv/project/front-org/src/components/global/feedback-form/FeedbackForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsContent"] */ "/srv/project/front-org/src/components/global/news/NewsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsForm"] */ "/srv/project/front-org/src/components/global/news/NewsForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsList"] */ "/srv/project/front-org/src/components/global/news/NewsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsView"] */ "/srv/project/front-org/src/components/global/news/NewsView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PagesView"] */ "/srv/project/front-org/src/components/global/pages-view/PagesView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Scripts"] */ "/srv/project/front-org/src/components/global/scripts/Scripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Input"] */ "/srv/project/front-org/src/components/global/search/Input.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Search"] */ "/srv/project/front-org/src/components/global/search/Search.tsx");
